import { formatTableData, getData } from '../utils/formatters';

interface WestPlainsData {
  address?: string;
  city?: string;
  zip?: string;
  lot?: string;
  parcelId?: string;
  ownerName?: string;
  ownerStreetAddress?: string;
  ownerCity?: string;
  ownerState?: string;
  ownerZip?: string;
  subdivisionName?: string;
  schoolDistrict?: string | number;
  schoolDistrictName?: string;
  fireDistrict?: string | number;
  taxDistrict?: string;
  neighborhood?: string;
  localDistrict?: string;
  stateDistrict?: string;
  districtName?: string;
  acres?: number;
  deedType?: string;
  zone?: string;
  zoningCode?: string;
  zoningLabel?: string;
  zoningDescription?: string;
  mapLink?: string;
  propertyCardLink?: string;
  taxBillLink?: string;
  imageLink?: string;
}

const WEST_PLAINS_ROWS = [
  {
    label: 'Address',
    getValue: (data: WestPlainsData) => getData(data, 'address', 'No address available')
  },
  {
    label: 'Zone',
    getValue: (data: WestPlainsData) => {
      const label = data.zoningLabel || data.zone;
      const code = data.zoningCode;
      if (label) {
        return code && code !== label ? `${label} (${code})` : label;
      }
      if (code) {
        return code;
      }
      return 'No zoning information available';
    }
  },
  {
    label: 'Zoning Description',
    getValue: (data: WestPlainsData) =>
      getData(data, 'zoningDescription', 'No zoning description available')
  },
  {
    label: 'City, Zip',
    getValue: (data: WestPlainsData) => `${getData(data, 'city', 'N/A')}, ${getData(data, 'zip', 'N/A')}`
  },
  {
    label: 'Parcel ID',
    getValue: (data: WestPlainsData) => getData(data, 'parcelId', 'No parcel ID available')
  },
  {
    label: 'Property Size',
    getValue: (data: WestPlainsData) => {
      const acres = getData(data, 'acreage', null);
      return acres ? `${acres} acres` : 'No property size information available';
    }
  },
  {
    label: 'Land Use',
    getValue: (data: WestPlainsData) => getData(data, 'landUse', 'No land use information available')
  },
  {
    label: 'Legal Description',
    getValue: (data: WestPlainsData) => getData(data, 'legalDescription', 'No legal description available')
  },
  {
    label: 'Section',
    getValue: (data: WestPlainsData) => getData(data, 'section', 'No section information available')
  },
  {
    label: 'School District',
    getValue: (data: WestPlainsData) => {
      const name = data.schoolDistrictName;
      const code = data.schoolDistrict;
      if (name) {
        return code !== undefined && code !== null && code !== ''
          ? `${name} (${String(code)})`
          : name;
      }
      if (code !== undefined && code !== null && code !== '') {
        return String(code);
      }
      return 'No school district information available';
    }
  },
];

export const formatWestPlainsData = (data: WestPlainsData): string => {
  return formatTableData(data, WEST_PLAINS_ROWS);
};
